import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('fluxipay_admin_token');
    const storedAdmin = localStorage.getItem('fluxipay_admin');
    
    if (storedToken && storedAdmin) {
      setToken(storedToken);
      setAdmin(JSON.parse(storedAdmin));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      
      const response = await fetch(`${backendUrl}/api/admin/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      if (response.ok) {
        const data = await response.json();
        
        // Guardar token y admin en localStorage
        localStorage.setItem('fluxipay_admin_token', data.access_token);
        localStorage.setItem('fluxipay_admin', JSON.stringify(data.admin));
        
        setToken(data.access_token);
        setAdmin(data.admin);
        return { success: true };
      } else {
        const error = await response.json();
        return { success: false, error: error.detail || 'Error al iniciar sesión' };
      }
    } catch (error) {
      return { success: false, error: 'Error al conectar con el servidor' };
    }
  };

  const logout = () => {
    localStorage.removeItem('fluxipay_admin_token');
    localStorage.removeItem('fluxipay_admin');
    setToken(null);
    setAdmin(null);
  };

  const fetchWithAuth = async (url, options = {}) => {
    const headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`
    };

    return fetch(url, { ...options, headers });
  };

  const value = {
    token,
    admin,
    merchant: admin, // Alias for compatibility with AdminLayout
    loading,
    isAuthenticated: !!token,
    login,
    logout,
    fetchWithAuth
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
